import {
  CheckCircleFilled,
  CloseCircleFilled,
  FileTextOutlined,
} from "@ant-design/icons";
import React from "react";

const StatusIndicator = ({ filledStatus, status }) => {
  return (
    <>
      {filledStatus === false && status === null ? (
        <span
          className="d-flex justify-content-center align-items-center"
          style={{
            border: "1.5px solid #E7E7E7",
            padding: "10px",
            borderRadius: "50%",
          }}
        >
          <FileTextOutlined style={{ fontSize: "2rem", color: "#999999" }} />
        </span>
      ) : (
        <>
          {(status === null || status === false) && filledStatus === true ? (
            <span
              className="d-flex justify-content-center align-items-center"
              style={{
                border: "1.5px solid #00AC1A",
                padding: "10px",
                borderRadius: "50%",
              }}
            >
              <CheckCircleFilled
                style={{ fontSize: "2rem", color: "#00AC1A" }}
              />
            </span>
          ) : (
            <>
              {status ? (
                <span
                  className="d-flex justify-content-center align-items-center"
                  style={{
                    border: "1.5px solid #00AC1A",
                    padding: "10px",
                    borderRadius: "50%",
                  }}
                >
                  <CheckCircleFilled
                    style={{ fontSize: "2rem", color: "#00AC1A" }}
                  />
                </span>
              ) : (
                <span
                  className="d-flex justify-content-center align-items-center"
                  style={{
                    border: "1.5px solid red",
                    padding: "10px",
                    borderRadius: "50%",
                  }}
                >
                  <CloseCircleFilled
                    style={{ fontSize: "2rem", color: "red" }}
                  />
                </span>
              )}
            </>
          )}
        </>
      )}
    </>
  );
};
export const VerifiedIndicator = () => {
  return (
    <div className="d-flex align-items-center">
      <img src="/img/verified.svg" className="mr-1"/>
      <span style={{fontSize:'1.2rem'}}>Verified</span>
    </div>
  )
}

export default StatusIndicator;
